import { gql, useMutation } from '@apollo/client';

import type { ApproveRemittanceRecordsVariables } from './__generated__/ApproveRemittanceRecords';
import type { RejectRemittanceRecordsVariables } from './__generated__/RejectRemittanceRecords';

export const APPROVE_REMITTANCE_RECORDS = gql`
  mutation ApproveRemittanceRecords($input: ApproveRemittanceRecordsInput!) {
    approveRemittanceRecords(input: $input)
  }
`;

export const REJECT_REMITTANCE_RECORDS = gql`
  mutation RejectRemittanceRecords($input: RejectRemittanceRecordsInput!) {
    rejectRemittanceRecords(input: $input)
  }
`;

export function useApproveRemittanceRecords() {
  return useMutation<{ approveRemittanceRecords: boolean }, ApproveRemittanceRecordsVariables>(
    APPROVE_REMITTANCE_RECORDS,
  );
}

export function useRejectRemittanceRecords() {
  return useMutation<{ rejectRemittanceRecords: boolean }, RejectRemittanceRecordsVariables>(
    REJECT_REMITTANCE_RECORDS,
  );
}
